import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Card, Collapse, Typography, Tag, Spin, Alert, Empty, Button, Space, Table, Divider, Modal, Form, Input, Segmented } from "antd";
import { DownOutlined, ReloadOutlined, TeamOutlined, ArrowLeftOutlined, } from "@ant-design/icons";
import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";

import Swal from "sweetalert2";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import "./CursosArmas.css";

const { Title, Text } = Typography;

const CursosPerfeccionamiento = () => {

  const navigate = useNavigate();
  // =========================================================
  // SEDE
  // =========================================================




  //const Usuario = ObtieneDatosCookies()

  



const sede = localStorage.getItem("sedeUsuario");

  // =========================================================
  // CURSOS
  // =========================================================

  const [cursos, setCursos] = useState([]);
  const [cantidadCursos, setCantidadCursos] = useState(0);

  const [loadingCursos, setLoadingCursos] = useState(false);
  const [error, setError] = useState("");

  // =========================================================
  // ALUMNOS POR CURSO
  // =========================================================

  const [alumnosPorCurso, setAlumnosPorCurso] = useState({});

  // Loading individual de cada curso
  const [loadingAlumnos, setLoadingAlumnos] = useState({});

  // Cursos que ya fueron consultados
  const [cursosConsultados, setCursosConsultados] = useState({});

  // =========================================================
  // AULA SELECCIONADA POR CURSO
  // =========================================================

  const [aulasSeleccionadas, setAulasSeleccionadas] = useState({});

  // =========================================================
  // MODAL EDICIÓN
  // =========================================================

  const [modalEditar, setModalEditar] = useState(false);
  const [alumnoEditar, setAlumnoEditar] = useState(null);

  // =========================================================
  // BÚSQUEDAS
  // =========================================================

  const [busquedasPorCurso, setBusquedasPorCurso] = useState({});

  // =========================================================
  // FILTRO DE ASISTENCIA (todos / presentes / ausentes)
  // =========================================================

  const [filtroAsistencia, setFiltroAsistencia] = useState({});

  // =========================================================
  // FORMULARIO
  // =========================================================

  const [form] = Form.useForm();

  // =========================================================
  // CONTROLAR SI LOS DATOS DEL ARMA ESTÁN INCOMPLETOS
  // =========================================================

  const filaIncompletaArma = (alumno) => {
    const arma = alumno?.arma;

    if (!arma) {
      return false;
    }

    const marca = Boolean(
      arma.marca_arma?.trim()
    );

    const modelo = Boolean(
      arma.modelo_arma?.trim()
    );

    const numero = Boolean(
      arma.numero_arma?.trim()
    );

    const cantidadDatos = [
      marca,
      modelo,
      numero,
    ].filter(Boolean).length;

    // Tiene algún dato pero no los tres
    return cantidadDatos > 0 && cantidadDatos < 3;
  };

  const tieneDatosArma = (alumno) => {
    const arma = alumno?.arma;

    if (!arma) {
      return false;
    }

    return Boolean(
      arma.marca_arma?.trim() ||
      arma.modelo_arma?.trim() ||
      arma.numero_arma?.trim()
    );
  };

  const armaCompleta = (alumno) => {
    const arma = alumno?.arma;

    if (!arma) {
      return false;
    }

    return Boolean(
      arma.marca_arma?.trim() &&
      arma.modelo_arma?.trim() &&
      arma.numero_arma?.trim()
    );
  };

  const obtenerEstadoArma = (alumno) => {
    if (armaCompleta(alumno)) {
      return "completo";
    }

    if (tieneDatosArma(alumno)) {
      return "incompleto";
    }

    return "sin_datos";
  };

  // =========================================================
  // ABRIR MODAL EDITAR
  // =========================================================

  const abrirEditar = (alumno) => {
    setAlumnoEditar(alumno);

    form.setFieldsValue({
      escalafon_subescalafon:
        alumno?.arma?.escalafon_subescalafon || "",

      unidad_destino:
        alumno?.arma?.unidad_destino || "",

      marca_arma:
        alumno?.arma?.marca_arma || "",

      modelo_arma:
        alumno?.arma?.modelo_arma || "",

      numero_arma:
        alumno?.arma?.numero_arma || "",

      numero_chaleco:
        alumno?.arma?.numero_chaleco || "",
    });

    setModalEditar(true);
  };

  // =========================================================
  // GENERAR PDF
  // FORMATO PLANILLA CONSUMO DE MUNICIÓN
  // =========================================================

  //console.log("Mi gerarquia es:" , jerarquia)

  const generarPlanillaPDF = (tipo, alumnos, jerarquia) => {
    // =======================================================
    // CONFIGURACIÓN
    // =======================================================

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const calibre =
      tipo === "Pistola"
        ? "9x19 mm"
        : "12/70";

    // =======================================================
    // ALUMNOS VÁLIDOS
    // =======================================================

    const alumnosValidos = alumnos.filter(
      (alumno) => !filaIncompletaArma(alumno)
    );

    if (alumnosValidos.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Sin alumnos",
        text: "No hay alumnos con datos de armamento completos para generar la planilla.",
      });

      return;
    }

    // =======================================================
    // FECHA
    // =======================================================

    const ahora = new Date();

    const meses = [
      "ENERO",
      "FEBRERO",
      "MARZO",
      "ABRIL",
      "MAYO",
      "JUNIO",
      "JULIO",
      "AGOSTO",
      "SEPTIEMBRE",
      "OCTUBRE",
      "NOVIEMBRE",
      "DICIEMBRE",
    ];

    const mes = meses[ahora.getMonth()];
    const anio = ahora.getFullYear();

    const fecha = ahora.toLocaleDateString(
      "es-AR",
      {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }
    );

    // =======================================================
    // FUNCIÓN ENCABEZADO
    // =======================================================

    const dibujarEncabezado = () => {
      doc.setTextColor(0, 0, 0);

      // -------------------------------------------------------
      // SUPERIOR DERECHA
      // -------------------------------------------------------

      doc.setFont(
        "helvetica",
        "bold"
      );

      doc.setFontSize(8.5);

      doc.text(
        "POLICÍA DE LA PROVINCIA DE SANTA FE",
        pageWidth - 10,
        8,
        {
          align: "right",
        }
      );

      doc.setFontSize(7);

      doc.text(
        "SECCIÓN TÉC. PREV. - UNIDAD: __________________________",
        pageWidth - 10,
        12,
        {
          align: "right",
        }
      );

      // -------------------------------------------------------
      // ANEXO
      // -------------------------------------------------------

      doc.setFont(
        "helvetica",
        "bold"
      );

      doc.setFontSize(10);

      doc.text(
        "ANEXO 2 PLANILLA PARA CAPACITACIÓN",
        pageWidth / 2,
        18,
        {
          align: "center",
        }
      );

      // -------------------------------------------------------
      // MES / AÑO
      // -------------------------------------------------------

      doc.setFontSize(7.5);

      doc.text(
        `MES: ${mes}`,
        105,
        23
      );

      doc.text(
        `AÑO: ${anio}`,
        175,
        23
      );

      // -------------------------------------------------------
      // TÍTULO PLANILLA
      // -------------------------------------------------------

      doc.setFontSize(8);

      doc.text(
        "PLANILLA DE CONSUMO DE MUNICIÓN PARA PRÁCTICAS DE TIRO - ANEXO 2",
        pageWidth / 2,
        28,
        {
          align: "center",
        }
      );

      // -------------------------------------------------------
      // TIPO
      // -------------------------------------------------------

      doc.setFont(
        "helvetica",
        "normal"
      );

      doc.setFontSize(7);

      doc.text(
        `Armamento: ${tipo.toUpperCase()}    -    Sede: ${sede}`,
        10,
        32
      );
    };

    dibujarEncabezado();

    // =======================================================
    // SERIES FIJAS PARA ESCOPETA
    // SE VAN REPITIENDO EN ESTE ORDEN
    // =======================================================

    const SERIES_ESCOPETA = [
      "235052",
      "235053",
      "235054",
      "152060",
      "659173",
    ];

    // =======================================================
    // FILAS
    // =======================================================

    const filas = alumnosValidos.map(
      (alumno, index) => {
        const arma = alumno?.arma || {};

        // Marca + modelo en la columna ARMA
        // (para Escopeta siempre decimos "Escopeta")
        const descripcionArma =
          tipo === "Escopeta"
            ? "Escopeta"
            : [
              arma.marca_arma,
              arma.modelo_arma,
            ]
              .filter(Boolean)
              .join(" ");

        // Serie: para Escopeta se toma de la lista fija,
        // repitiendo en orden.
        const serie =
          tipo === "Escopeta"
            ? SERIES_ESCOPETA[
            index %
            SERIES_ESCOPETA.length
            ]
            : arma.numero_arma || "";

        // Apellido, nombre y jerarquía
        const nombreCompleto = [
          `${alumno.apellido || ""}, ${alumno.nombres || ""}`,
          jerarquia || "",
        ]
          .filter(Boolean)
          .join(" - ");

        return [
          fecha,

          `ISeP ${sede}`,

          calibre,

          "", // Cantidad

          descripcionArma,

          serie,

          nombreCompleto,

          alumno.ni ||
          "",

          arma.unidad_destino || "", // Destino

          "", // Firma

          "", // Vainas recibidas
        ];
      }
    );

    // =======================================================
    // TABLA
    // =======================================================

    autoTable(doc, {
      startY: 35,

      margin: {
        left: 6,
        right: 6,
        bottom: 10,
      },

      head: [
        [
          "Fecha",
          "Lugar de\nPráctica",
          "Calibre",
          "Cantidad",
          "ARMA",
          "SERIE",
          "Apellido, Nombre y Jerarquía",
          "N.I.",
          "DESTINO",
          "Firma del participante\n(Caracter de declaración)",
          "Vainas\nRecibidas",
        ],
      ],

      body: filas,

      theme: "grid",

      styles: {
        font: "helvetica",
        fontSize: 6.5,

        textColor: [
          0,
          0,
          0,
        ],

        lineColor: [
          0,
          0,
          0,
        ],

        lineWidth: 0.2,

        cellPadding: 1,

        valign: "middle",

        halign: "center",

        overflow: "linebreak",
      },

      headStyles: {
        fillColor: [
          255,
          255,
          255,
        ],

        textColor: [
          0,
          0,
          0,
        ],

        fontStyle: "bold",

        lineColor: [
          0,
          0,
          0,
        ],

        lineWidth: 0.3,

        halign: "center",

        valign: "middle",

        fontSize: 6.2,

        minCellHeight: 15,
      },

      bodyStyles: {
        minCellHeight: 9,
      },

      columnStyles: {
        // Fecha
        0: {
          cellWidth: 18,
        },

        // Lugar de práctica
        1: {
          cellWidth: 26,
        },

        // Calibre
        2: {
          cellWidth: 17,
        },

        // Cantidad
        3: {
          cellWidth: 16,
        },

        // Arma
        4: {
          cellWidth: 30,
        },

        // Serie
        5: {
          cellWidth: 23,
        },

        // Apellido nombre jerarquía
        6: {
          cellWidth: 60,
          halign: "left",
        },

        // NI
        7: {
          cellWidth: 21,
        },

        // Destino
        8: {
          cellWidth: 20,
        },

        // Firma
        9: {
          cellWidth: 40,
        },

        // Vainas
        10: {
          cellWidth: 18,
        },
      },

      rowPageBreak: "avoid",

      pageBreak: "auto",

      showHead: "everyPage",

      didParseCell: (data) => {
        if (
          data.section === "body"
        ) {
          data.cell.styles.minCellHeight = 9;
        }
      },

      // =====================================================
      // ENCABEZADOS / PIE DE TODAS LAS PÁGINAS
      // =====================================================

      didDrawPage: (data) => {
        // En páginas posteriores volvemos a mostrar
        // parte del encabezado institucional.

        if (data.pageNumber > 1) {
          doc.setFont(
            "helvetica",
            "bold"
          );

          doc.setFontSize(7);

          doc.text(
            "POLICÍA DE LA PROVINCIA DE SANTA FE",
            pageWidth - 10,
            8,
            {
              align: "right",
            }
          );

          doc.setFontSize(8);

          doc.text(
            `PLANILLA DE CONSUMO DE MUNICIÓN - ${tipo.toUpperCase()}`,
            pageWidth / 2,
            12,
            {
              align: "center",
            }
          );
        }

        // -----------------------------------------------------
        // NÚMERO DE PÁGINA
        // -----------------------------------------------------

        doc.setFont(
          "helvetica",
          "normal"
        );

        doc.setFontSize(7);

        doc.text(
          `Página ${data.pageNumber}`,
          pageWidth / 2,
          pageHeight - 4,
          {
            align: "center",
          }
        );
      },
    });

    // =======================================================
    // GUARDAR
    // =======================================================

    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    window.open(pdfUrl, "_blank");
  };

  // =========================================================
  // GENERAR PLANILLA
  // =========================================================

  const generarPlanilla = (
    alumnosAula,
    jerarquia
  ) => {
    Swal.fire({
      title:
        "Generar Planilla",

      text:
        "Seleccione el tipo de armamento",

      showDenyButton: true,

      confirmButtonText:
        "Pistola",

      denyButtonText:
        "Escopeta",

      showCancelButton: true,

      cancelButtonText:
        "Cancelar",
    }).then(
      (result) => {
        if (
          result.isConfirmed
        ) {
          generarPlanillaPDF(
            "Pistola",
            alumnosAula,
            jerarquia
          );
        }

        if (
          result.isDenied
        ) {
          generarPlanillaPDF(
            "Escopeta",
            alumnosAula,
            jerarquia
          );
        }
      }
    );
  };

  // =========================================================
  // GUARDAR CAMBIOS
  // =========================================================

  const guardarCambios = async () => {
    try {
      if (!alumnoEditar) {
        return;
      }

      const valores =
        await form.validateFields();

      const payload = {
        dni:
          alumnoEditar.dni,

        escalafon_subescalafon:
          valores.escalafon_subescalafon,

        unidad_destino:
          valores.unidad_destino,

        marca_arma:
          valores.marca_arma,

        modelo_arma:
          valores.modelo_arma,

        numero_arma:
          valores.numero_arma,

        numero_chaleco:
          valores.numero_chaleco,

        estado:
          alumnoEditar.arma?.estado ||
          "Activo",
      };

      console.log(
        "ENVIANDO:",
        payload
      );

      const response =
        await axios.post(
          "https://wwwp.isepsantafe.net.ar/armeria/arma-vigilante/guardar",
          payload
        );

      console.log(
        "RESPUESTA:",
        response.data
      );

      // =====================================================
      // ACTUALIZAR LOCALMENTE
      // PARA NO TENER QUE RECARGAR TODO
      // =====================================================

      setAlumnosPorCurso(
        (prev) => {
          const copia = {
            ...prev,
          };

          Object.keys(
            copia
          ).forEach(
            (idCurso) => {
              copia[idCurso] =
                copia[
                  idCurso
                ].map(
                  (
                    alumno
                  ) => {
                    if (
                      String(
                        alumno.dni
                      ) !==
                      String(
                        alumnoEditar.dni
                      )
                    ) {
                      return alumno;
                    }

                    return {
                      ...alumno,

                      arma: {
                        ...alumno.arma,

                        escalafon_subescalafon:
                          valores.escalafon_subescalafon,

                        unidad_destino:
                          valores.unidad_destino,

                        marca_arma:
                          valores.marca_arma,

                        modelo_arma:
                          valores.modelo_arma,

                        numero_arma:
                          valores.numero_arma,

                        numero_chaleco:
                          valores.numero_chaleco,
                      },
                    };
                  }
                );
            }
          );

          return copia;
        }
      );

      setModalEditar(false);

      setAlumnoEditar(null);

      form.resetFields();

      Swal.fire({
        icon: "success",
        title: "Guardado",
        text: "Los datos del armamento fueron actualizados.",
        timer: 1500,
        showConfirmButton:
          false,
      });
    } catch (error) {
      console.error(
        "ERROR:",
        error.response?.data ||
        error.message
      );

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data
            ?.message ||
          error.response?.data
            ?.detail ||
          "No se pudieron guardar los cambios.",
      });
    }
  };

  // =========================================================
  // CONSULTAR CURSOS
  // =========================================================

  const consultarCursos = async () => {
    try {
      setLoadingCursos(true);

      setError("");

      const response =
        await axios.post(
          "https://wwwp.isepsantafe.net.ar/armeria/cursos-perfeccionamiento",
          {
            sede,
          }
        );

      const data =
        response.data;

      if (data.success) {
        setCursos(
          data.cursos || []
        );

        setCantidadCursos(
          data.cantidadCursos ||
          0
        );
      } else {
        setCursos([]);

        setCantidadCursos(0);

        setError(
          "No se pudieron obtener los cursos."
        );
      }
    } catch (err) {
      console.error(err);

      setCursos([]);

      setCantidadCursos(0);

      setError(
        err.response?.data
          ?.detail ||
        "Ocurrió un error al consultar los cursos."
      );
    } finally {
      setLoadingCursos(false);
    }
  };

  // =========================================================
  // CONSULTAR ALUMNOS DEL CURSO
  // =========================================================

  const consultarAlumnos = async (idCurso) => {

    console.log("==========================================");
    console.log("🚀 INICIANDO CONSULTA DE ALUMNOS");
    console.log("📚 ID CURSO:", idCurso);
    console.log("==========================================");

    // Si ya consultamos este curso, no volvemos a consultar
    if (cursosConsultados[idCurso]) {

      console.log(
        "⚠️ CURSO YA CONSULTADO - NO SE REALIZA NUEVA CONSULTA:",
        idCurso
      );

      return;
    }

    try {

      setLoadingAlumnos((prev) => ({
        ...prev,
        [idCurso]: true,
      }));

      console.log("📡 ENVIANDO REQUEST...");
      console.log("📚 ID CURSO:", idCurso);

      const response = await axios.post(
        "https://wwwp.isepsantafe.net.ar/armeria/alumnos-perfeccionamiento-id",
        {
          idCurso: Number(idCurso),
        }
      );

      console.log("✅ RESPONSE RECIBIDA");
      console.log("STATUS:", response.status);
      console.log("DATA COMPLETA:", response.data);

      const data = response.data;

      if (!data.success) {

        console.error(
          "❌ EL BACKEND DEVOLVIÓ success=false",
          data
        );

        setAlumnosPorCurso((prev) => ({
          ...prev,
          [idCurso]: [],
        }));

        return;
      }

      // =====================================================
      // CURSANTES
      // =====================================================

      const cursantes = Array.isArray(data.cursantes)
        ? data.cursantes
        : [];

      console.log("==========================================");
      console.log("👥 CURSANTES RECIBIDOS");
      console.log("CURSO:", idCurso);
      console.log("CANTIDAD:", cursantes.length);
      console.log("CURSANTES:", cursantes);
      console.log("==========================================");

      // =====================================================
      // ASISTENCIA
      // =====================================================

      const presentes = cursantes.filter(
        (alumno) => alumno.presente === true
      );

      const ausentes = cursantes.filter(
        (alumno) => alumno.presente !== true
      );

      console.log("==========================================");
      console.log("📋 ASISTENCIA DE HOY");
      console.log("📅 FECHA:", data.fecha);
      console.log("👥 TOTAL:", cursantes.length);
      console.log("🟢 PRESENTES:", presentes.length);
      console.log("🔴 AUSENTES:", ausentes.length);
      console.log("==========================================");

      console.log("🟢 ALUMNOS PRESENTES:");

      presentes.forEach((alumno) => {
        console.log(
          `DNI: ${alumno.dni} | ${alumno.apellido}, ${alumno.nombres} | PRESENTE:`,
          alumno.presente
        );
      });

      console.log("🔴 ALUMNOS AUSENTES:");

      ausentes.forEach((alumno) => {
        console.log(
          `DNI: ${alumno.dni} | ${alumno.apellido}, ${alumno.nombres} | PRESENTE:`,
          alumno.presente
        );
      });

      console.log("==========================================");



      // =====================================================
      // PRIMER ALUMNO
      // =====================================================

      if (cursantes.length > 0) {

        console.log("==========================================");
        console.log("🔎 30 ALUMNO COMPLETO");
        console.log(cursantes.slice(0, 30));
        console.log("DNI:", cursantes[0].dni);
        console.log("NI:", cursantes[0].ni);
        console.log("PRESENTE:", cursantes[0].presente);
        console.log("ARMA:", cursantes[0].arma);
        console.log("==========================================");
      }

      // =====================================================
      // GUARDAR ALUMNOS
      // =====================================================

      setAlumnosPorCurso((prev) => ({
        ...prev,
        [idCurso]: cursantes,
      }));

      setCursosConsultados((prev) => ({
        ...prev,
        [idCurso]: true,
      }));

      // =====================================================
      // OBTENER AULAS / DIVISIONES
      // =====================================================

      const divisiones = [
        ...new Set(
          cursantes
            .map((alumno) => alumno.division)
            .filter(
              (division) =>
                division !== null &&
                division !== undefined &&
                division !== ""
            )
        ),
      ].sort(
        (a, b) => Number(a) - Number(b)
      );

      console.log("==========================================");
      console.log("🏫 AULAS DEL CURSO:", divisiones);
      console.log("==========================================");

      if (divisiones.length > 0) {

        setAulasSeleccionadas((prev) => ({
          ...prev,
          [idCurso]: divisiones[0],
        }));

        console.log(
          "🏫 AULA SELECCIONADA AUTOMÁTICAMENTE:",
          divisiones[0]
        );
      }

    } catch (err) {

      console.error("==========================================");
      console.error("❌ ERROR CONSULTANDO CURSO");
      console.error("CURSO:", idCurso);
      console.error("ERROR:", err);
      console.error(
        "RESPUESTA:",
        err.response?.data
      );
      console.error("==========================================");

      setAlumnosPorCurso((prev) => ({
        ...prev,
        [idCurso]: [],
      }));

    } finally {

      setLoadingAlumnos((prev) => ({
        ...prev,
        [idCurso]: false,
      }));

      console.log(
        "🏁 FINALIZÓ CONSULTA CURSO:",
        idCurso
      );
    }
  };

  // =========================================================
  // CARGAR CURSOS
  // =========================================================

  useEffect(() => {
    consultarCursos();
  }, []);

  // =========================================================
  // OBTENER JERARQUÍA
  // =========================================================

  // Lista ordenada de MÁS específico a MENOS específico,
  // para que términos compuestos (ej. "SUBOFICIAL") se
  // evalúen antes que sus términos contenidos (ej. "OFICIAL").
  const JERARQUIAS = [
    {
      patrones: [
        "CRIO. SUPERVISOR",
        "CRIO SUPERVISOR",
        "COMISARIO SUPERVISOR",
      ],
      label: "CRIO. SUPERVISOR",
    },
    { patrones: ["SUBCOMISARIO"], label: "SUBCOMISARIO" },

    { patrones: ["COMISARIO", "CRIO."], label: "COMISARIO" },

    { patrones: ["SUBINSPECTOR"], label: "SUBINSPECTOR" },

    { patrones: ["INSPECTOR"], label: "INSPECTOR" },

    { patrones: ["SUBOFICIAL"], label: "SUBOFICIAL" },

    { patrones: ["OFICIAL"], label: "OFICIAL" }

  ];

  const obtenerJerarquia = (
    nombreCurso
  ) => {
    if (!nombreCurso) {
      return "";
    }

    const nombreNormalizado =
      nombreCurso
        .toString()
        .toUpperCase();

    const encontrada =
      JERARQUIAS.find(
        (jerarquia) =>
          jerarquia.patrones.some(
            (patron) =>
              nombreNormalizado.includes(
                patron
              )
          )
      );

    if (encontrada) {
      return encontrada.label;
    }

    return nombreCurso;
  };

  // =========================================================
  // OBTENER AULAS / DIVISIONES
  // =========================================================

  const obtenerAulas = (
    idCurso
  ) => {
    const alumnos =
      alumnosPorCurso[
      idCurso
      ] || [];

    const divisiones = [
      ...new Set(
        alumnos
          .map(
            (alumno) =>
              alumno.division
          )
          .filter(
            (
              division
            ) =>
              division !==
              null &&
              division !==
              undefined &&
              division !== ""
          )
      ),
    ];

    return divisiones.sort(
      (a, b) =>
        Number(a) -
        Number(b)
    );
  };

  // =========================================================
  // ALUMNOS DEL AULA SELECCIONADA
  // =========================================================

  const obtenerAlumnosAula = (idCurso) => {
    const alumnos =
      alumnosPorCurso[idCurso] || [];

    const aulaSeleccionada =
      aulasSeleccionadas[idCurso];

    if (
      aulaSeleccionada === null ||
      aulaSeleccionada === undefined
    ) {
      return [];
    }

    // =====================================================
    // FILTRAR POR AULA
    // =====================================================

    let resultado = alumnos.filter(
      (alumno) =>
        Number(alumno.division) ===
        Number(aulaSeleccionada)
    );

    const busqueda = (
      busquedasPorCurso[idCurso] || ""
    )
      .trim()
      .toLowerCase();

    // =====================================================
    // SIN BÚSQUEDA
    // SOLO QUIENES TIENEN ARMAMENTO
    // =====================================================

    if (!busqueda) {
      resultado = resultado.filter((alumno) => {
        const arma = alumno.arma;

        if (!arma) {
          return false;
        }

        const tieneEscalafon =
          arma.escalafon_subescalafon &&
          arma.escalafon_subescalafon.trim() !== "";

        const tieneDatoArma =
          (
            arma.marca_arma &&
            arma.marca_arma.trim() !== ""
          ) ||
          (
            arma.modelo_arma &&
            arma.modelo_arma.trim() !== ""
          ) ||
          (
            arma.numero_arma &&
            arma.numero_arma.trim() !== ""
          );

        return (
          tieneEscalafon &&
          tieneDatoArma
        );
      });
    }

    // =====================================================
    // CON BÚSQUEDA
    // BUSCAR A TODOS
    // =====================================================

    else {
      resultado = resultado.filter((alumno) => {
        const dni = String(
          alumno.dni || ""
        ).toLowerCase();

        const apellido = String(
          alumno.apellido || ""
        ).toLowerCase();

        const nombres = String(
          alumno.nombres || ""
        ).toLowerCase();

        return (
          dni.includes(busqueda) ||
          apellido.includes(busqueda) ||
          nombres.includes(busqueda)
        );
      });
    }

    // =====================================================
    // FILTRO DE ASISTENCIA
    // =====================================================

    const filtro = filtroAsistencia[idCurso] || "todos";

    if (filtro === "presentes") {
      resultado = resultado.filter(
        (alumno) => alumno.presente === true
      );
    }

    if (filtro === "ausentes") {
      resultado = resultado.filter(
        (alumno) => alumno.presente !== true
      );
    }

    return resultado;
  };
  // =========================================================
  // COLUMNAS TABLA
  // =========================================================

  const columns = [
    {
      title: "DNI",

      dataIndex: "dni",

      key: "dni",

      width: 120,

      align: "center",
    },

    {
      title: "Apellido",

      dataIndex:
        "apellido",

      key: "apellido",

      width: 180,
    },

    {
      title: "Nombres",

      dataIndex:
        "nombres",

      key: "nombres",

      width: 220,
    },

    {
      title: "Escalafón",

      key: "escalafon",

      width: 180,

      render: (
        _,
        alumno
      ) =>
        alumno.arma
          ?.escalafon_subescalafon ||
        "SIN DATOS",
    },

    {
      title: "Unidad destino",
      key: "unidad_destino",
      width: 180,
      render: (_, alumno) =>
        alumno.arma?.unidad_destino || "SIN DATOS",
    },

    {
      title: "Marca arma",

      key: "marca_arma",

      width: 130,

      render: (
        _,
        alumno
      ) =>
        alumno.arma
          ?.marca_arma ||
        "SIN DATOS",
    },

    {
      title: "Modelo arma",

      key: "modelo_arma",

      width: 140,

      render: (
        _,
        alumno
      ) =>
        alumno.arma
          ?.modelo_arma ||
        "SIN DATOS",
    },

    {
      title: "N° Arma",

      key: "numero_arma",

      width: 130,

      render: (
        _,
        alumno
      ) =>
        alumno.arma
          ?.numero_arma ||
        "SIN DATOS",
    },

    {
      title: "Acciones",

      key: "acciones",

      width: 120,

      render: (
        _,
        alumno
      ) => (
        <Button
          type="primary"
          onClick={() =>
            abrirEditar(
              alumno
            )
          }
        >
          Editar
        </Button>
      ),
    },
  ];

  // =========================================================
  // RENDER DEL CONTENIDO DEL CURSO
  // =========================================================

  const renderCurso = (
    curso
  ) => {
    const idCurso =
      curso.idCurso;

    const jerarquia =
      obtenerJerarquia(
        curso.nombreCurso
      );

    // =====================================================
    // LOADING
    // =====================================================

    if (
      loadingAlumnos[
      idCurso
      ]
    ) {
      return (
        <div
          style={{
            textAlign:
              "center",

            padding: 50,
          }}
        >
          <Spin size="large" />

          <div
            style={{
              marginTop: 15,
            }}
          >
            <Text type="secondary">
              Cargando
              alumnos...
            </Text>
          </div>
        </div>
      );
    }

    const alumnos =
      alumnosPorCurso[
      idCurso
      ] || [];

    // =====================================================
    // SIN ALUMNOS
    // =====================================================

    if (!alumnos.length) {
      return (
        <Empty
          image={
            Empty.PRESENTED_IMAGE_SIMPLE
          }
          description="No hay alumnos para este curso"
        />
      );
    }

    // =====================================================
    // AULAS
    // =====================================================

    const aulas =
      obtenerAulas(
        idCurso
      );

    const aulaSeleccionada =
      aulasSeleccionadas[
      idCurso
      ];

    const alumnosAula =
      obtenerAlumnosAula(
        idCurso
      );

    const alumnosCompletos = alumnosAula.filter(
      (alumno) => obtenerEstadoArma(alumno) === "completo"
    ).length;

    const alumnosIncompletos = alumnosAula.filter(
      (alumno) => obtenerEstadoArma(alumno) === "incompleto"
    ).length;

    const alumnosSinDatos = alumnosAula.filter(
      (alumno) => obtenerEstadoArma(alumno) === "sin_datos"
    ).length;

    const alumnosPresentes = alumnosAula.filter(
      (alumno) => alumno.presente === true
    ).length;

    const alumnosAusentes = alumnosAula.filter(
      (alumno) => alumno.presente !== true
    ).length;

    return (
      <div>
        {/* ============================================== */}
        {/* AULAS */}
        {/* ============================================== */}

        <div
          style={{
            marginBottom: 20,
          }}
        >
          <div
            style={{
              display: "flex",

              alignItems:
                "center",

              gap: 10,

              marginBottom: 15,
            }}
          >
            <TeamOutlined />

            <Text
              strong
              style={{
                fontSize: 16,
              }}
            >
              Aulas
            </Text>

            <Tag color="blue">
              {aulas.length}
            </Tag>
          </div>

          <Space wrap>
            {aulas.map(
              (aula) => (
                <Button
                  key={aula}
                  type={
                    Number(
                      aulaSeleccionada
                    ) ===
                      Number(
                        aula
                      )
                      ? "primary"
                      : "default"
                  }
                  onClick={() => {
                    setAulasSeleccionadas(
                      (
                        prev
                      ) => ({
                        ...prev,

                        [idCurso]:
                          aula,
                      })
                    );
                  }}
                >
                  AULA {aula}
                </Button>
              )
            )}
          </Space>
        </div>

        <Divider />

        {/* ============================================== */}
        {/* ALUMNOS DEL AULA */}
        {/* ============================================== */}

        {aulaSeleccionada !==
          undefined &&
          aulaSeleccionada !==
          null ? (
          <div>
            <div
              style={{
                display: "flex",

                justifyContent:
                  "space-between",

                alignItems:
                  "center",

                flexWrap:
                  "wrap",

                gap: 10,

                marginBottom: 15,
              }}
            >
              <Title
                level={5}
                style={{
                  margin: 0,
                }}
              >
                Alumnos - Aula{" "}
                {
                  aulaSeleccionada
                }
              </Title>

              <Space wrap>

                <Input.Search
                  placeholder="Buscar DNI, apellido o nombres"
                  allowClear
                  style={{
                    width: 300,
                  }}
                  value={
                    busquedasPorCurso[idCurso] || ""
                  }
                  onChange={(e) =>
                    setBusquedasPorCurso((prev) => ({
                      ...prev,
                      [idCurso]:
                        e.target.value,
                    }))
                  }
                />

                <Tag color="green">
                  {alumnosCompletos} completos
                </Tag>

                <Tag color="orange">
                  {alumnosIncompletos} incompletos
                </Tag>

                <Tag color="gold">
                  {alumnosSinDatos} sin datos
                </Tag>

                <Tag color="cyan">
                  {alumnosPresentes} presentes
                </Tag>

                <Tag color="red">
                  {alumnosAusentes} ausentes
                </Tag>

                <Segmented
                  value={
                    filtroAsistencia[idCurso] || "todos"
                  }
                  onChange={(value) => {
                    setFiltroAsistencia((prev) => ({
                      ...prev,
                      [idCurso]: value,
                    }));
                  }}
                  options={[
                    { label: "Todos", value: "todos" },
                    { label: "Presentes", value: "presentes" },
                    { label: "Ausentes", value: "ausentes" },
                  ]}
                />

                <Button
                  type="primary"
                  danger
                  onClick={() =>
                    generarPlanilla(
                      alumnosAula,
                      jerarquia
                    )
                  }
                >
                  Generar Planilla
                </Button>

              </Space>
            </div>

            <Table
              rowKey={(
                record
              ) =>
                record.dni
              }
              columns={
                columns
              }
              dataSource={
                alumnosAula
              }
              bordered
              size="middle"
              pagination={
                false
              }
              scroll={{
                x: 1250,
              }}
              rowClassName={(record) => {
                const estado = obtenerEstadoArma(record);

                if (estado === "completo") {
                  return "fila-arma-completa";
                }

                if (estado === "incompleto") {
                  return "fila-arma-incompleta";
                }

                return "fila-arma-sin-datos";
              }}
            />
          </div>
        ) : (
          <Empty
            image={
              Empty.PRESENTED_IMAGE_SIMPLE
            }
            description="Seleccione un aula"
          />
        )}
      </div>
    );
  };

  // =========================================================
  // ITEMS COLLAPSE
  // =========================================================
  // 1. Definir el mapa de orden (ponelo antes de usarlo)
  const ordenJerarquias = {
    "SUBOFICIAL": 1,
    "OFICIAL": 2,
    "SUBINSPECTOR": 3,
    "INSPECTOR": 4,
    "SUBCOMISARIO": 10,
    "COMISARIO": 11,
    "CRIO. SUPERVISOR": 12,
    "DIRECTOR Y DIRECTOR": 13,
  };

  const obtenerOrdenJerarquia = (nombreCurso) => {
    const jerarquia = obtenerJerarquia(nombreCurso);
    return ordenJerarquias[jerarquia] || 999;
  };

  // 2. Ordenar los cursos
  const cursosOrdenados = [...cursos].sort((a, b) => {
    const ordenA = obtenerOrdenJerarquia(a.nombreCurso);
    const ordenB = obtenerOrdenJerarquia(b.nombreCurso);
    return ordenA - ordenB;
  });



  const items = cursosOrdenados.map((curso) => {
    const jerarquia = obtenerJerarquia(curso.nombreCurso);

    const alumnos =
      alumnosPorCurso[
      curso.idCurso
      ] || [];

    const aulas =
      obtenerAulas(
        curso.idCurso
      );

    // Conteo general del curso
    const incompletosCurso = alumnos.filter(filaIncompletaArma).length;
    const completosCurso = alumnos.length - incompletosCurso;

    return {
      key: String(
        curso.idCurso
      ),

      label: (
        <div
          style={{
            display:
              "flex",

            justifyContent:
              "space-between",

            alignItems:
              "center",

            width:
              "100%",

            paddingRight:
              15,

            flexWrap:
              "wrap",

            gap: 10,
          }}
        >
          <Space size="middle">
            <Text
              strong
              style={{
                fontSize:
                  17,
              }}
            >
              {jerarquia}
            </Text>
          </Space>
        </div>
      ),

      children:
        renderCurso(
          curso
        ),
    };
  }
  );

  // =========================================================
  // CAMBIO DEL ACORDEÓN
  // =========================================================
  const handleCollapseChange = (key) => {

    console.log("==========================================");
    console.log("🔽 COLLAPSE CAMBIÓ");
    console.log("KEY RECIBIDA:", key);
    console.log("TIPO:", typeof key);
    console.log("==========================================");

    if (!key) {

      console.log(
        "ℹ️ COLLAPSE CERRADO"
      );

      return;
    }

    // Como tenemos accordion=true,
    // normalmente Ant Design devuelve un string.
    // Lo hacemos robusto por las dudas.

    const activeKey = Array.isArray(key)
      ? key[0]
      : key;

    console.log(
      "🔑 ACTIVE KEY:",
      activeKey
    );

    const idCurso = Number(activeKey);

    console.log(
      "📚 ID CURSO CONVERTIDO:",
      idCurso
    );

    if (!idCurso) {

      console.error(
        "❌ ID DE CURSO INVÁLIDO:",
        activeKey
      );

      return;
    }

    console.log(
      "🔍 ¿YA FUE CONSULTADO?",
      cursosConsultados[idCurso]
    );

    if (cursosConsultados[idCurso]) {

      console.log(
        "⚠️ ESTE CURSO YA ESTÁ CARGADO:",
        idCurso
      );

      return;
    }

    console.log(
      "🚀 LLAMANDO consultarAlumnos():",
      idCurso
    );

    consultarAlumnos(idCurso);
  };

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <div
      style={{
        padding: 24,
      }}
    >
      <Card>
        {/* ============================================== */}
        {/* ENCABEZADO */}
        {/* ============================================== */}

        <div
          style={{
            display: "flex",

            justifyContent:
              "space-between",

            alignItems:
              "center",

            flexWrap: "wrap",

            gap: 15,

            marginBottom: 25,
          }}
        >
          <div>
            <Title
              level={3}
              style={{
                margin: 0,
              }}
            >
              Cursos de
              Perfeccionamiento
              2027
            </Title>

            <Text type="secondary">
              Cursos disponibles
              para la sede{" "}
              <strong>
                {sede}
              </strong>
            </Text>
          </div>

          <Space wrap>
            <Tag
              color="blue"
              style={{
                fontSize: 14,
                padding: "6px 12px",
              }}
            >
              Sede: {sede}
            </Tag>

            <Button
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate("/usuarioLogueado")}
              style={{
                backgroundColor: "#F4C542",
                borderColor: "#F4C542",
                color: "#000",
              }}
            >
              Volver
            </Button>
          </Space>
        </div>

        {/* ============================================== */}
        {/* ERROR */}
        {/* ============================================== */}

        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            style={{
              marginBottom: 20,
            }}
          />
        )}

        {/* ============================================== */}
        {/* CURSOS */}
        {/* ============================================== */}

        {loadingCursos ? (
          <div
            style={{
              display: "flex",

              justifyContent:
                "center",

              padding: 60,
            }}
          >
            <Spin size="large" />
          </div>
        ) : cursos.length ===
          0 ? (
          <Empty description="No hay cursos disponibles" />
        ) : (
          <Collapse
            accordion
            items={items}
            onChange={
              handleCollapseChange
            }
            expandIcon={({
              isActive,
            }) => (
              <DownOutlined
                rotate={
                  isActive
                    ? 180
                    : 0
                }
              />
            )}
          />
        )}
      </Card>

      {/* ================================================= */}
      {/* MODAL EDITAR ARMAMENTO */}
      {/* ================================================= */}

      <Modal
        title={`Editar armamento - ${alumnoEditar?.apellido || ""}`}
        open={
          modalEditar
        }
        onCancel={() => {
          setModalEditar(
            false
          );

          setAlumnoEditar(
            null
          );

          form.resetFields();
        }}
        onOk={
          guardarCambios
        }
        okText="Guardar"
        cancelText="Cancelar"
        destroyOnClose
      >
        <Form
          form={form}
          layout="vertical"
        >
          <Form.Item label="DNI">
            <Input
              value={
                alumnoEditar?.dni
              }
              disabled
            />
          </Form.Item>

          <Form.Item label="Apellido">
            <Input
              value={
                alumnoEditar?.apellido
              }
              disabled
            />
          </Form.Item>

          <Form.Item label="Nombres">
            <Input
              value={
                alumnoEditar?.nombres
              }
              disabled
            />
          </Form.Item>

          <Form.Item
            name="escalafon_subescalafon"
            label="Escalafón"
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="unidad_destino"
            label="Unidad destino"
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="marca_arma"
            label="Marca arma"
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="modelo_arma"
            label="Modelo arma"
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="numero_arma"
            label="Número arma"
          >
            <Input />
          </Form.Item>

          {/*<Form.Item
            name="numero_chaleco"
            label="Número chaleco"
          >
            <Input />
          </Form.Item>*/}
        </Form>
      </Modal>
    </div>
  );
};

export default CursosPerfeccionamiento;